import { CloseIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import {
  DialogTitle as MuiDialogTitle,
  IconButton,
  Typography,
} from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/Dialog/components/DialogTitle/DialogTitle.styles';

type DialogTitleProps = {
  title: string;
  handleClose: () => void;
};

const DialogTitle = ({ title, handleClose }: DialogTitleProps) => {
  const classes = useStyles();

  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h3" fontWeight="bold">
        {title}
      </Typography>
      <IconButton onClick={handleClose} className={classes.iconButton}>
        <CloseIcon data-testid={`${title}Dialog-cross-icon`} />
      </IconButton>
    </MuiDialogTitle>
  );
};

export default DialogTitle;
